var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-shell" }, [
    _c("aside", { staticClass: "admin-side" }, [
      _vm._m(0),
      _c("nav", { staticClass: "side-nav" }, [
        _c(
          "a",
          {
            staticClass: "nav-item",
            class: { active: _vm.nav === "pages" },
            on: {
              click: function ($event) {
                return _vm.go("/admin/pages")
              },
            },
          },
          [
            _c("span", { staticClass: "nav-ico" }, [_vm._v("▤")]),
            _vm._v(" 页面管理 "),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "nav-item",
            class: { active: _vm.nav === "create" },
            on: {
              click: function ($event) {
                return _vm.go("/admin/edit")
              },
            },
          },
          [
            _c("span", { staticClass: "nav-ico" }, [_vm._v("＋")]),
            _vm._v(" 新建页面 "),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "nav-item",
            class: { active: _vm.nav === "visits" },
            on: {
              click: function ($event) {
                return _vm.go("/admin/visits")
              },
            },
          },
          [
            _c("span", { staticClass: "nav-ico" }, [_vm._v("◷")]),
            _vm._v(" 访问记录 "),
          ]
        ),
        _c("a", { staticClass: "nav-item", on: { click: _vm.openSite } }, [
          _c("span", { staticClass: "nav-ico" }, [_vm._v("↗")]),
          _vm._v(" 打开前台 "),
        ]),
      ]),
      _c("div", { staticClass: "side-foot" }, [
        _c("div", { staticClass: "api-line", attrs: { title: _vm.API_BASE } }, [
          _vm._v("接口：" + _vm._s(_vm.API_BASE)),
        ]),
        _c("button", { staticClass: "btn-ghost", on: { click: _vm.logout } }, [
          _vm._v("退出登录"),
        ]),
      ]),
    ]),
    _c("main", { staticClass: "admin-main" }, [
      _c("header", { staticClass: "admin-head" }, [
        _c("h2", { staticClass: "head-title" }, [_vm._v(_vm._s(_vm.title))]),
        _c("div", { staticClass: "head-right" }, [
          _vm.subtitle
            ? _c("span", { staticClass: "head-sub" }, [
                _vm._v(_vm._s(_vm.subtitle)),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "admin-body" },
        [
          _c("router-view", {
            key: _vm.reloadKey,
            on: {
              changed: function ($event) {
                _vm.reloadKey++
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "side-brand" }, [
      _c("span", { staticClass: "brand-mark" }, [_vm._v("信")]),
      _c("span", { staticClass: "brand-name" }, [_vm._v("信 箱 后 台")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }